import { formatDurationSeconds } from '../../../../utils/date'
import { TableTextCell } from '../TableTextCell'

function TableDurationCell({ value, ...cellProps }) {
  return <TableTextCell {...cellProps} value={formatDurationSeconds(value)} />
}

export default TableDurationCell
